import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

// Gets an overview of the agent associated with the currently authenticated account
async function getCurrentAgentOverview() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.get(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.CONTACT_CENTRE_AGENT_CURRENT,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

async function cancelRequestAssistance(agentID) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.post(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.CONTACT_CENTER_CALL_MANAGER_CLEAR_ASSISTANCE_REQUEST_FIRST + agentID + CONSTANTS.API_CONSTANTS.ENDPOINTS.CONTACT_CENTER_CALL_MANAGER_CLEAR_ASSISTANCE_REQUEST_SECOND,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export default {
  getCurrentAgentOverview,
  cancelRequestAssistance,
};
